import React from 'react';
import { useLocation } from 'react-router-dom';
import LinkComponent from '../../../components/common/Link';
import NewsForm from '../newsCreation/newsForm';

const NewsEdition = () => {
  const location = useLocation();
  const newsId = (location && location.state && location.state.id) || null;

  return (
    <div className="client-container">
      <div className="client__back-container">
        <LinkComponent title="Volver" url="/novedades" icon="arrow_back" />
      </div>
      <NewsForm mode="edit" newsId={newsId} />
    </div>
  );
};

export default NewsEdition;
